import { ApiClient } from '../lib/api';
import { z } from 'zod';

const LoginRequestSchema = z.object({
  username: z.string(),
  password: z.string(),
  company: z.string(),
});

const LoginResponseSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
  uemail: z.string(),
  ufirstn: z.string(),
  uid: z.number(),
  ulastn: z.string(),
  ulogin: z.string(),
  uphone: z.string(),
});

type LoginRequest = z.infer<typeof LoginRequestSchema>;
type LoginResponse = z.infer<typeof LoginResponseSchema>;

export class AuthService {
  private readonly api: ApiClient;

  constructor(baseURL: string, stage: string) {
    this.api = new ApiClient(`${baseURL}/${stage}/authentication-${stage}`, stage);
  }

  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await this.api.request(
      {
        method: 'POST',
        url: '/login',
        data: LoginRequestSchema.parse(credentials),
      },
      LoginResponseSchema
    );

    this.api.setAccessToken(response.access_token);
    this.api.setRefreshToken(response.refresh_token);

    return response;
  }
} 